import Wrapper from '@app/Wrapper.js'

Munio.Tinker = class extends Wrapper {
  constructor(selector) {
    super(selector)
  }

  component() {
    return import('./App.vue')
  }
}
